<!-- 快手落地页用户 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 0 0 0;">
			<div class="screen-box">
				<div class="screen-label">跳转日期</div>
				<a-range-picker style="width:240px;" @change="onChangeDate" :allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">跳转时间</div>
				<a-range-picker style="width:340px;"
				:locale="locale" allowClear
				:show-time="{ format: 'HH:mm:ss' }" 
				format="YYYY-MM-DD HH:mm:ss" 
				@change="onChangeDateB"
				@ok="onDateC_ok" 
				/>
			</div>
			
			
			<div class="screen-box">
				<div class="screen-label">公众号</div>
				
				<moreSelect
				 ref="getGzhSelect"
				:placeholder="'请选择公众号'"
				:select_mode="''"
				@handleChangeSelect="handleChangeB"
				></moreSelect>
			</div>
			
			
			<div class="screen-box">
				<div class="screen-label">落地页ID</div>
				<a-input v-model="r_link_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">计划ID</div>
				<a-input v-model="r_adid" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">创意ID</div>
				<a-input v-model="r_creativeid" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">ip</div>
				<a-input v-model="r_ip" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">推广链接ID</div>
				<a-input v-model="r_promotion_link_id" allowClear placeholder="请输入" style="width: 200px;"  />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">是否匹配上注册用户</div>
				<a-select style="width: 150px;" 
				 @change="handleChangeD" allowClear placeholder="请选择" 
				 :getPopupContainer="getsPopupContainer">
					<a-select-option value="1">是</a-select-option>
					<a-select-option value="0">否</a-select-option>
				</a-select>
			</div>
			

			
			<a-button @click="searchButton('button')" :loading="search_button_loading" class="screen-box" type="primary" icon="search">搜索</a-button>
			<!-- <a-button @click="exportButton" type="primary" icon="download" class="screen-box" >导出</a-button> -->
		</div>
	</div>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell"
				:style="{'width':rableTitle[0].width + 'px'}" >
					{{rableTitle[0].title}}
				</div>
				<div class="table-th-cell"
				:style="{'width':rableTitle[1].width + 'px'}" >
					{{rableTitle[1].title}}
				</div>
				<div class="table-th-cell"
				:style="{'width':rableTitle[2].width + 'px'}" >
					{{rableTitle[2].title}}
				</div>
				
			</div>
			<div v-for="(item,index) in rableTitle" :key="index" >
				<div v-if="index > 2" class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- ID -->
				<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
					{{item.id}}
				</div>
				<!-- 投放日期 -->
				<div class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
					{{item.date_key}}
				</div>
				<!-- 公众号 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
					{{item.gzh_name}}
				</div>
			</div>
			<!-- 落地页ID -->
			<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
				{{item.link_id}}
			</div>
			<!-- 广告点击时间 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}">
				{{item.clk_time }}
			</div>
			<!-- 落地页跳转时间 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}">
				{{item.click_time }}
			</div>
			<!-- ip -->
			<div  class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}">
				{{item.ip }}
			</div>
			<!-- 地区 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[7].width + 'px'}">
				{{item.province}}  {{item.city}}
			</div>
			
			<!-- 账户id -->
			<div  class="table-td-cell" :style="{'width':rableTitle[8].width + 'px'}">
				{{item.account_id}}
			</div>
			<!-- 广告组id -->
			<div  class="table-td-cell" :style="{'width':rableTitle[9].width + 'px'}">
				{{item.aid}}
			</div>
			<!-- 计划id -->
			<div  class="table-td-cell" :style="{'width':rableTitle[10].width + 'px'}">
				{{item.did}}
			</div>
			<!-- 创意id -->
			<div  class="table-td-cell" :style="{'width':rableTitle[11].width + 'px'}">
				{{item.cid}}
			</div>
			<!-- 推广链接ID -->
			<div  class="table-td-cell" :style="{'width':rableTitle[12].width + 'px'}">
				{{item.promotion_link_id}}
			</div>
			
			<!-- 回传参数 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[13].width + 'px'}">
				<!-- {{item.callback}} -->
				<a-popover placement="top">
					<template slot="content">
					  <p style="width: 320px;word-break: break-all;">{{item.callback}}</p>
					</template>
					<div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;height: 39px;">
						{{item.callback}}
					</div>
				</a-popover>
			</div>
			<!-- 是否匹配上注册用户 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[14].width + 'px'}">
				{{item.has_register == 1?'是':'否'}}
			</div>
			
			<!-- 操作 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[15].width + 'px'}">
				<div @click="HcTdTable(item,0)" style="color: #62a8ea;cursor: pointer;">手动联调快手</div>
			</div>
		</div>
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<!-- 分页 -->
		<div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 41px;">
			<div style="text-align: center;margin-top: 30px;position: sticky;left: 30px;" :style="{'width': table_null_width + 'px',}">
				<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" :showTotal="(total, range) => `共 ${total} 条`" @change="paginationChange" hideOnSinglePage/>
			</div>
		</div>
	</div>
	
	<!-- 手动回传 -->
	<a-modal :visible="hc_visible" title="确认要回传？" @ok="hcOk" @cancel="hcCancel" 
	cancelText="取消" okText="确认" :confirmLoading="hc_confirm_loading">
	    <div>ID：{{hc_id}}</div>
	</a-modal>
	
	<!-- 自定义回传 -->
	<!-- <a-modal :visible="hc_Zdy_visible" title="自定义回传" @ok="hcZdyOk" @cancel="hcZdyCancel"
	cancelText="取消" okText="确认" :confirmLoading="hc_Zdy_loading">
		<div class="form-cell-box">
			<div class="class-title">落地页用户类型</div>
			<a-select
				:value="h_report_id_type"
			    style="width: 290px"
			    placeholder="请选择"
			    @change="handleChangeH"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
				<a-select-option value="0">自建落地页</a-select-option>
				<a-select-option value="1">基木鱼</a-select-option>
				<a-select-option value="3">巨量点击检测</a-select-option>
			</a-select>
		</div>
		
	    <div class="form-cell-box">
	    	<div class="class-title">落地页用户ID</div>
	    	<a-input v-model="h_report_id" placeholder="前往对应落地页用户类型页面复制ID" style="width: 290px;"  />
	    </div>
	</a-modal> -->
	
	<!-- 图片查看 -->
	<a-modal v-model="img_visible" width="350px" title="图片展示" @ok="imgOk" okText="确认" cancelText="取消" :footer="null">
	    <img style="width: 300px;max-height: 600px;object-fit: contain;" :src="code_img_show" alt="">
	</a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { putDataMenu, LdKsList, LdKsReport, orderGzhCustomReport,  } from '@/request/api'
import moreSelect from '@/components/selectCompont/moreSelect.vue'
export default {
	name: 'LPks_',
	components: {
		moreSelect
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2022-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			filterList: { // 搜索条件内容
				channel_id: {},
				gzh_id: {},
			}, 
			click_start_date: '', // 点击日期
			click_end_date: '', // 点击日期
			show_click_start: '', // 点击日期开始
			show_click_end: '', // 点击日期结束
			
			PlatformData: {},
			is_admin: false, // 为true表示 超级管理员
			is_super: false, // 为true表示放管理
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:80, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"跳转日期", width:100, type:"date_key", },
				{title:"公众号", width:120, type:"gzh_name", },
				{title:"落地页ID", width:120, type:"link_id", },
				{title:"广告点击时间", width:160, type:"clk_time", },
				{title:"落地页跳转时间", width:160, type:"click_time", },
				{title:"IP", width:160, type:"ip", },
				{title:"地区", width:160, type:"province，city", },
				
				{title:"账户ID", width:160, type:"account_id", },
				
				{title:"广告组ID", width:160, type:"aid", },
				{title:"计划ID", width:160, type:"did", },
				{title:"创意ID", width:160, type:"cid", },
				{title:"推广链接ID", width:160, type:"promotion_link_id", },
				
				{title:"回传参数", width:160, type:"callback", },
				{title:"是否匹配上注册用户", width:160, type:"has_register", }, // 0=否，1=是
				
				// {title:"点击Id", width:150, type:"click_id", },
				// {title:"ua", width:160, type:"ua", },
				
				// {title:"注册回传次数", width:160, type:"reg_callback_times", }, 
				// {title:"注册上报时间", width:160, type:"reg_report_time", }, 
				
				// {title:"是否充值", width:160, type:"has_pay", }, // 0=否，1=是
				// {title:"充值回传次数", width:100, type:"report_count", },
				// {title:"回传时间", width:100, type:"report_time", },
				
				
				{title:"操作", width:150, type:"cz", },
				
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false, // 搜索按钮的加载状态
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			
			r_gzh_id: null, // 公众号id
			r_link_id: null, // 落地页ID
			r_has_register: null,  // 是否已经注册 0=否，1=是
			r_adid: null, // 计划ID
			r_creativeid: null, // 创意ID
			r_ip: null, // ip
			r_promotion_link_id: null, // 推广链接id
			
			hc_id: "", // 手动回传id
			hc_visible: false, // 手动回传弹窗
			hc_confirm_loading: false, 
			hc_Zdy_visible: false, 
			hc_Zdy_loading: false,
			h_report_id: "", // 落地页用户ID
			h_report_id_type: undefined, // 落地页用户类型
			
			code_img_show: "", // 二维码图片显示
			img_visible: false,
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		if(that.table_scroll_width >= that.body_width){ that.table_null_width = that.body_width - 60 }
		else { that.table_null_width = that.table_scroll_width - 60 }
		
		setTimeout(()=>{
			// 给母页面的tab传递粘性定位用的参数
			that.$bus.$emit("stickyData", that.table_scroll_width);
		},300)
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		
		// 获取7天前日期
		// that.startTime = this.$getBeforeDay(7)
		// 获取当前日期
		that.endTime = this.$getThisDay()
		that.startTime = this.$getThisDay()
		
		putDataMenu().then(res=>{
			console.log('putDataMenu',res)
			that.filterList = res.data.data.filter
			// 公众号
			that.$refs.getGzhSelect.getSelectData(that.filterList.gzh_id.list || [])
			
			that.is_admin = res.data.data.is_admin
			
			// 搜索
			that.searchButton()
		})
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 点击日期
		onChangeDateB(date, dateString){
			console.log('点击日期',date, dateString);
			this.click_start_date = dateString[0]
			this.click_end_date = dateString[1]
			
			// if(dateString[0]){
			// 	this.show_click_start = this.moment(dateString[0], this.dateFormat) || '' // 点击日期开始
			// 	this.show_click_end = this.moment(dateString[1], this.dateFormat) || '' // 点击日期结束
			// }
			// else {
			// 	this.show_click_start =  '' // 点击日期开始
			// 	this.show_click_end =  '' // 点击日期结束
			// }
			
			
			// this.click_start_date = dateString[0]
			// this.click_end_date = dateString[1]
		},
		handleChangeB(e){ // 公众号
			console.log(e);
			this.r_gzh_id = e
		},
		handleChangeD(e){ // 是否已经注册 // 0=否，1=是
			console.log(e);
			this.r_has_register = e
		},
		
		handleChangeH(e){ // 落地页用户类型
			this.h_report_id_type = e
		},
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			let s_date,e_date
			if(that.click_start_date){
				s_date = that.click_start_date
				e_date = that.click_end_date
			}
			else {
				s_date = ""
				e_date = ""
			}
			
			// 点击按钮进行条件搜索的时候，要把页数变成1，否则相关内容可能搜索不出来。
			if(type == 'button'){
				that.r_page = 1
			}
			
			LdKsList({
				limit: that.r_limit,
				page: that.r_page,
				start_date: that.startTime.replace(/-/g, ''),
				end_date: that.endTime.replace(/-/g, ''),
				click_start_date: s_date, // 点击日期开始
				click_end_date: e_date, // 点击日期结束
				
				gzh_id: that.r_gzh_id, // 公众号id
				link_id: that.r_link_id, // 落地页ID
				has_register: that.r_has_register,  // 是否已经注册 0=否，1=是
				adid: that.r_adid, // 计划ID
				creativeid: that.r_creativeid, // 创意ID
				ip: that.r_ip, // ip
				promotion_link_id: that.r_promotion_link_id, // 推广链接ID
			}).then(res=>{
				console.log('搜索',res);
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					// that.is_super = res.data.data.is_super // 是否是投放管理员
					
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		
		// 回传操作
		HcTdTable(e,type){
			if(type == 0){ // 手动回传头条
				this.hc_id = e.id
				this.hc_visible = true
			}
			else if(type == 1){ // 自定义回传
				this.hc_id = e.id
				this.hc_Zdy_visible = true
				
			}
		},
		// 手动回传弹窗确认按钮
		hcOk(){
			let that = this
			that.hc_confirm_loading = true
			LdKsReport({
				id: that.hc_id
			}).then(res=>{
				console.log("快手手动联调",res);
				that.hc_confirm_loading = false
				
				if(res.data.code == 0 || res.data.code == 200){
					that.hcCancel()
					that.$message.success('操作成功');
					that.searchButton()
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(res.data.msg || '操作失败');
					}
				}
			})
			.catch(err=>{
				that.hc_confirm_loading = false
				console.log("err",err)
				that.$message.error("操作失败，可能是服务器出现问题");
			})
		},
		hcCancel(){
			if(this.hc_confirm_loading){
				return
			}
			this.hc_visible = false
		},
		// 自定义回传
		hcZdyOk(){
			let that = this
			if(!that.h_report_id_type){
				that.$message.warning('落地页用户类型不能为空');
				return
			}
			else if(!that.h_report_id){
				that.$message.warning('落地页用户ID不能为空');
				return
			}
			
			that.hc_Zdy_loading = true
			orderGzhCustomReport({
				order_id: that.hc_id,
				report_id: that.h_report_id,
				report_id_type: that.h_report_id_type,
			}).then(res=>{
				console.log("自定义回传",res);
				that.hc_Zdy_loading = false
				
				if(res.data.code == 0){
					that.hcZdyCancel()
					that.$message.success('操作成功');
					that.searchButton()
				}
				else {
					that.$message.error(res.data.msg || '操作失败');
				}
				
			})
			.catch(err=>{
				that.hc_Zdy_loading = false
				console.log("err",err)
				that.$message.error("操作失败，可能是服务器出现问题");
			})
		},
		hcZdyCancel(){
			if(this.hc_Zdy_loading){
				return
			}
			this.h_report_id = ""
			this.h_report_id_type = undefined
			this.hc_Zdy_visible = false
		},
		
		// 二维码图片显示
		showCodeImg(e){
			console.log(e);
			this.code_img_show = 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + e.qr_code_ticket
			this.img_visible = true
		},
		imgOk(){
			
		},
		
		onDateC_ok(value){
			// console.log('onOk: ', value);
		},
	},
	filters: {
		clickDate(value){
			let ttt = value
			// console.log(value);
			//时间戳转化成时间格式
			function timeFormat(value) {
			    //value是整数，否则要parseInt转换,不会出现少个0的情况
			    //如果value是10位数的需要 value* 1000
			    var time = new Date(value* 1000);
				// console.log('time',time);
			    var year = time.getFullYear();
				// console.log('time',time);
			    var month = time.getMonth() + 1;
			    var date = time.getDate();
			    var hours = time.getHours();
			    var minutes = time.getMinutes();
			    var seconds = time.getSeconds();
			    return year + '-' + add0(month) + '-' + add0(date) + ' ' + add0(hours) + ':' + add0(minutes) + ':' + add0(seconds);
			}
			function add0(m) {
			    return m < 10 ? '0' + m : m
			};
			// console.log(timeFormat(value));
			return timeFormat(value)
		}
	}
}
</script>

<style scoped>
.class-title {
	width: 100px;
}

.table-td-cell {
	font-size: 13px;
}
</style>